import React from "react";
import "./accommodations.css";
import img from "../../../assets/images/accomodationcard.png";
import Icon from "../../Icon";
import { faBuilding } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

const AccommodationCard = ({data = {}}) => {
  return (
    <div className="accommodation-card ">
        <img src={data?.file?.Url || img} alt="" />
      <Link to={`/search-result?city=${data.name}`}>
        <div className="accommodation-card-description">
          <div className="px-2 pb-2">
            <>
              <h6 className="mb-0 text-light text-capitalize accommodation-card-title">{data?.name ||'vrindavan'}</h6>
            </>
            <div className="w-100 h-100">
              <span className="">
                <Icon icon={faBuilding} className="text-warning" />
                &nbsp;
                &nbsp;
                <span className="text-light text-capitalize">{data?.propertyCount || '0'} Properties</span>
              </span>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default AccommodationCard;
